import { authHermitHeaders } from 'actions';
import axios from 'axios';
import { authHeaders, Header, HeaderDocumentDetail } from './auth';
import {
    ACTIVE_SHIPMENT_DOCUMENTS,
    ACTIVE_SHIPMENT_DOCUMENTS_TASK,
    ACTIVE_SHIPMENT_DOCUMENTS_REMOVE_TASK,
    ACTIVE_SHIPMENT_DOCUMENTS_REMOVE_DEFAULT,
    GENERATE_TRADE_TRUST,
    GET_TRADE_TRUST,
    GET_DOCUMENT_TASK_DEFAULT,
    ACTIVE_SHIPMENT_DOCUMENTS_DEFAULT_TASK,
    ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE,
    ACTIVE_SHIPMENT_DOCUMENT_DETAILS,
    ETHEREUM,
    ETHEREUM_DETAIL,
    DOCUMENT_FETCH_ETHEREUM,
    DOCUMENT_FETCH_PARTIES,
    TRANSFER_HOLDER,
    NOMINATE_OWNER_SHIP,
    DOCUMENT_HOLDER_TRANSFER,
    DOCUMENT_OWNER_NOMINATE,
    ENDORSEMENTCHAIN,
    DIRECT_ENDORSEMENT_CHAIN,
    SURRENDER_DOCUMENT,
    DOCUMENT_PREVIEW_COMMENT,
    DOCUMENT_SIGNATURE_DETAIL,
    UPDATE_PARTNERS
} from './constants';

/** Get all documents
 * @param {
 * 		page: number
 * } params
 */

export const getDocuments = (shipmentId, params, token) => {
    if (!params) return;
    return axios.get(ACTIVE_SHIPMENT_DOCUMENTS.replace(':shipmentId', shipmentId), params ? {
        params,
        ...authHeaders(token)
    } : authHeaders(token));
}

/** remove documents of a task
 * @param {
 * 		ids: []
 * } payload
 */
export const removeDocumentsTask = (taskId, payload, token) => {
    if (!payload) return;
    return axios.delete(ACTIVE_SHIPMENT_DOCUMENTS_REMOVE_TASK.replace(':taskId', taskId), {
        data: payload,
        ...authHeaders(token)
    });
}

export const removeDocumentsDefault = (taskId, payload, token) => {
    if (!payload) return;
    return axios.delete(ACTIVE_SHIPMENT_DOCUMENTS_REMOVE_DEFAULT.replace(':taskId', taskId), {
        data: payload,
        ...authHeaders(token)
    });
}

/** upload documents of a task
 * @param {
 * 		ids: []
 * } payload
 */
export const uploadDocumentsTask = (taskId, payload, token) => {
    if (!payload) return;
    return axios.put(ACTIVE_SHIPMENT_DOCUMENTS_TASK.replace(':taskId', taskId), payload, authHeaders(token));
}

/** upload documents of a task in task daskboard
* @param {
* 		ids: []
* } payload
*/
export const uploadTaskDashboard = (taskId, payload, token) => {
    if (!payload) return;
    return axios.post(ACTIVE_SHIPMENT_DOCUMENTS_TASK.replace(':taskId', taskId), payload, authHeaders(token));
}

/** generate tradeTrust
    */
export const generateTradeTrust = (taskId, fileName, shipmentId, token) => {
    return axios.post(`${GENERATE_TRADE_TRUST.replace(":taskId", taskId)}?fileName=${fileName}&shipmentId=${shipmentId}`, null, authHeaders(token));
}


/** get tradeTrust
    */
export const getTradeTrust = (taskId, ids, token) => {
    return axios.post(`${GET_TRADE_TRUST.replace(":taskId", taskId)}`, ids, authHeaders(token));
}


/** get document task default
    */
 export const getDocumentTaskDefault = (shipmentId, token) => {
    return axios.get(`${GET_DOCUMENT_TASK_DEFAULT.replace(":shipmentId", shipmentId)}`, authHeaders(token));
}

/** upload documents of a task default
* @param {
* 		ids: []
* } payload
*/
export const uploadDocumentTaskDefault = (taskId, payload, token) => {
    if (!payload) return;
    return axios.put(ACTIVE_SHIPMENT_DOCUMENTS_DEFAULT_TASK.replace(':taskId', taskId), payload, authHeaders(token));
}

     /** Get documents signature 
 * @param {
    *       shipmentId: string,
    * } payload
    */
      export const getDocumentSignatureList = (shipmentId, token) => {
        if (!shipmentId) return;
        return axios.get(ACTIVE_SHIPMENT_DOCUMENT_SIGNATURE, authHermitHeaders(token))
      }
    
           /** Get documents signature status
 * @param {
    *       documentId: string,
    * } payload
    */
      export const getDocumentSignatureStatuses = (documentId, token) => {
        if (!documentId) return;
          return axios.get(ACTIVE_SHIPMENT_DOCUMENT_DETAILS.replace(':documentId', documentId),  authHermitHeaders(token));
    }
export const generateDocument = (documentId, payload, partyAccount, type, orgId, token) => {
    return axios.post(ETHEREUM.replace(':documentId', documentId), payload, Header(partyAccount, type, orgId, token));
}

export const generateDocumentDetail = (documentId, orgId, token) => {
    return axios.get(ETHEREUM_DETAIL + documentId, HeaderDocumentDetail(orgId, token));
}

export const getEthereum = (params, header, token) => {
    return axios.get(DOCUMENT_FETCH_ETHEREUM, params ? {
        params,
        headers: {
            'Authorization': token,
            'blockchain' : header.blockchain,
            'invokingParty': header.wallet,
            'organizationid': header.orgId
        }
    } : authHermitHeaders(token))
};
export const getParties = (params, header, token) => {
    return axios.get(DOCUMENT_FETCH_PARTIES, params ? {
        params,
        headers: {
            'Authorization': token,
            'blockchain' : header.blockchain,
            'invokingParty': header.wallet,
        }
    } : authHermitHeaders(token))
};

export const transferHolder = (documentId, payload, token) => {
    if (!documentId) {
        return;
    }
    return axios.post(TRANSFER_HOLDER.replace(':documentId', documentId), payload, authHermitHeaders(token));
}

export const nominateOwnerShip = (documentId, payload, token) => {
    if(!documentId) return;
    return axios.post(NOMINATE_OWNER_SHIP.replace(':documentId', documentId), payload, authHermitHeaders(token));
}

export const directEndorsementHolder = (documentId, payload, token) => {
    return axios.post(DOCUMENT_HOLDER_TRANSFER.replace(':documentId', documentId), payload, authHermitHeaders(token));
}

export const directEndorsementOwner = (documentId, payload, token) => {
    return axios.post(DOCUMENT_OWNER_NOMINATE.replace(':documentId', documentId), payload, authHermitHeaders(token));
}

export const getEndorsementChain = (params, header, token) => {
    return axios.get(ENDORSEMENTCHAIN, params ? {params,
        headers: {
            'Authorization': token,
            'blockchain' : header.blockchain,
            'invokingParty': header.wallet,
        }}: authHermitHeaders(token))
};

export const directEndorsementChain = (documentId, payload, partyAccount, typeBlockChain, orgId, token) => {
    return axios.post(DIRECT_ENDORSEMENT_CHAIN.replace(':documentId', documentId), payload, Header(partyAccount, typeBlockChain, orgId, token))
}

export const surrenderDocument = (documentId, payload, header, token) => {
    if(!documentId) return;
    return axios.post(SURRENDER_DOCUMENT.replace(':documentId', documentId), payload, Header(header?.wallet, header?.blockchain, header?.orgId, token));
}
export const commentPreviewDocument = (documentId, payload, token) => {
    if (!payload) return;
    return axios.post(DOCUMENT_PREVIEW_COMMENT.replace(':documentId', documentId), payload, authHermitHeaders(token))
    }

export const getDocumentVersions = (documentId, token) => {
    if (!documentId) return;
    return axios.get(DOCUMENT_SIGNATURE_DETAIL.replace(':documentId', documentId), authHermitHeaders(token))
}

export const updatePartners = (documentId, payload, token) => {
    if(!documentId) return;
    return axios.put(UPDATE_PARTNERS.replace(':documentId', documentId), payload, authHermitHeaders(token));
}
export const getDocument = (documentId, orgId, token) => {
    if (!documentId) return;
    return axios.get(ACTIVE_SHIPMENT_DOCUMENT_DETAILS.replace(':documentId', documentId), {
        headers: {
            'Authorization': token,
            'organizationid': orgId
        }
    })
}